/*
    Este componente permite que se envien los 3 elementos:
    1.- Sidebar 
    2.- Topbar
    3.- Content

*/

import React, { useState } from "react";
import {Container,Row,Col, Button} from "react-bootstrap";


import styles from './SideMenuTopBarLayout.module.scss';

import logo from 'assets/img/logo_glifos_moon.png';
// import logo from 'assets/img/magdalena_logo.svg';
import SideMenu from "./SideMenu/SideMenu";
// import Topbar from "./Topbar/Topbar";
import sidebaroptions from "routes/AppMenuOptions";
import { ArrowLeftCircle } from "react-bootstrap-icons";
import { ArrowRightCircle } from "react-bootstrap-icons";

export default function SideMenuTopBarLayout(props){
    
    const {classes} = props;
    // const [sidebarStatus, setSidebarStatus] = useState(true);
    let extraClassNames = "sm-layout-wrapper ";
    if (classes instanceof Array){
        extraClassNames+= classes.join(" ");
    }
    // console.log(sidebaroptions)
    //function displayToggle(){
    // setSidebarStatus((previousState)=> !previousState);
    //}
    return  <Container className={styles.container+ " g-0 "+ extraClassNames} fluid>
                <Row className={styles.mainrow + " g-0"}>
                    <Col xs={1}  className={styles.sidebarBackground + " "+ styles.sidebarwrapperd + " d-flex flex-column flex-shrink-0 p-3 text-white  bxg-dark"}>      
                        <SideMenu logo={logo} logoalt="Glifos" options={sidebaroptions}/>     
                    </Col>
                    <Col xs={11} className={styles.pagecontentcolumn}>
                    <Row>
                        {/* <Col xs={12} className={styles.navbarwrapper + " " + styles.sidebarBackground}>
                            <Topbar logo={logo} style={styles} />
                        </Col> */}
                        <Col xs={12} className={styles.pagecontentwrapper}>
                            <React.Suspense fallback={<div>Loading...</div>}>
                                {props.children}
                            </React.Suspense>
                        </Col>
                    </Row>
                </Col>
                </Row>
            </Container>
    ;
}